import React from 'react';
import { useOutlet } from 'react-router-dom';
import FormValidation from 'reactjs-forms';

export default function AuthFormLayout() {
  const outlet = useOutlet();

  return <FormValidation>{outlet}</FormValidation>;
}
